export enum JobType {
  reply = 'reply',
  firstContact = 'first_contact',
  reminderNoresponse = 'reminder_noresponse',
  followUp30Days = 'follow_up_30_days',
  followUp90Days = 'follow_up_90_days',
  followUp180Days = 'follow_up_180_days',
  followUp365Days = 'follow_up_365_days',
  followUpToDo = 'follow_up_to_do',
  followUpDone = 'follow_up_done',
  smsAnalysis = 'sms_analysis',
  /** A contact workflow run (helpers/workflows), not an SMS: never picked by the SMS crons */
  workflow = 'workflow',
}

export const jobTypeAsString = (type: JobType | string): string => {
  switch (type) {
    case JobType.reply:
      return '📝 Nouvelle réponse';
    case JobType.firstContact:
      return '🤝 Message de premier contact';
    case JobType.reminderNoresponse:
      return '🔔 Message de rappel si pas de réponse';
    case JobType.followUp30Days:
      return '📅 Suivi dans 30 jours';
    case JobType.followUp90Days:
      return '📅 Suivi dans 90 jours';
    case JobType.followUp180Days:
      return '📅 Suivi dans 180 jours';
    case JobType.followUp365Days:
      return '📅 Suivi dans 365 jours';
    case JobType.followUpToDo:
      return '🟡 Qualification en attente de réponse';
    case JobType.followUpDone:
      return '✅ Suivi terminé';
    case JobType.workflow:
      return '⚙️ Workflow';
    default:
      if (typeof type === 'string' && type.includes('_days')) {
        // Extract the number of days from the string
        const match = type.match(/(\d+)_days/);
        if (match) {
          return `📅 Suivi dans ${match[1]} jours`;
        }
      }
      return '';
  }
};